import { css, type SerializedStyles } from '@emotion/react';

import { styleguideColors } from '@/Client/Styles/kaiShikiTokens';
import { styleguideSpacing } from '@kaiizen/kai-shiki/core';

export type MobileWebWarningStyles = {
  message: SerializedStyles;
};

export const DEFAULT_MOBILE_WEB_WARNING_STYLES: MobileWebWarningStyles = {
  message: css`
    label: MOBILE_WEB_WARNING_MESSAGE;
    color: ${styleguideColors.textSecondary};
    margin: 0 0 ${styleguideSpacing.s3}px;

    &:last-of-type {
      margin-bottom: 0;
    }
  `,
};
